module.exports = __webpack_public_path__ + "img/RX-RAD-CONVENCIONAL-Moviles-5.ccd5912e.png";